/* eslint-disable quotes */
/* eslint-disable max-len */
import React, { Component } from 'react';
import centerfieldIcon from '../images/cf-logo.svg';

export class AgentLockedOutConfirmation extends Component {
  render() {
    return (
      <div className="AIV">
        <div className="AIV__hdr">
          <img src={centerfieldIcon} alt="centerfield-icon" className="AIV__hdr-logo" />
          <div className="AIV__hdr-text">
            Incomplete Verification
          </div>
        </div>
        <div className="AIV__title">
          Your Agent Portal access is locked due to an incomplete personal verification process.
          <br/>
          <br/>
          Please check your email and follow the link provided to complete process.
        </div>
      </div>
    );
  }
}

export default AgentLockedOutConfirmation;


// WEBPACK FOOTER //
// ./src/features/agent-info-verification/components/AgentLockedOutConfirmation.js